import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DropdownMC from '../../components/DropdownMC';
import { formatOutboundLineLabel } from '../../hooks/voice/domain/voiceSipStatus';

const CALL_LINE_DROPDOWN_ID = 'whatsapp-call-line-from';

/**
 * Selector for the WhatsApp business line used as outbound `from`.
 * Option labels use `name (phone)` when the MS account name is available.
 */
const CallLineSelector = memo(({
  enabledLines,
  selectedFrom,
  onChange,
  disabled = false,
  variant = 'dark'
}) => {
  const { t } = useTranslation('Fonema');

  const lineOptions = useMemo(
    () => (enabledLines || []).map((line) => ({
      id: line.businessE164,
      label: formatOutboundLineLabel(line)
    })),
    [enabledLines]
  );

  if (!enabledLines || enabledLines.length < 2) {
    return null;
  }

  const isDark = variant === 'dark';
  const labelClass = isDark ? 'tw-text-blue-100' : 'tw-text-gray-700';
  const buttonClassName = isDark
    ? '!tw-bg-blue-900 !tw-border-blue-700 !tw-text-blue-50 !tw-py-1.5 !tw-text-xs !tw-rounded-md !tw-px-2'
    : '!tw-bg-white !tw-border-gray-300 !tw-text-gray-900 !tw-py-1.5 !tw-text-xs !tw-rounded-md !tw-px-2';
  const selectedLabelClassName = isDark ? '!tw-text-blue-50' : '!tw-text-gray-900';

  return (
    <div className={`tw-flex tw-flex-col tw-gap-1 tw-mt-2 tw-text-xs ${labelClass}`}>
      <span>{t('callFrom')}</span>
      <DropdownMC
        id={CALL_LINE_DROPDOWN_ID}
        options={lineOptions}
        defaultValue={selectedFrom || ''}
        onSelect={onChange}
        disabled={disabled}
        placeholder={t('selectCallFrom')}
        className="tw-w-full"
        buttonClassName={buttonClassName}
        labelClassName={selectedLabelClassName}
      />
    </div>
  );
});

CallLineSelector.displayName = 'CallLineSelector';

export default CallLineSelector;
